import { SetupPermission } from 'src/app/core';
import { PermissionsC } from 'src/permissions/helpers/permissions.class';

export const Settings: SetupPermission = PermissionsC.setupPages({
  pageLabels: ['webhooks-management'],
  productLineLabel: 'developer-settings',
});
